export default __webpack_public_path__ + "static/rsz_cd3d_logo_2020-8774053ecc80d83c1bb9690c569cca37.png";